export default {
    SET: 'SET_SUMMARY_DATA'
};
